import { ActionTypes } from "../../Actions/ActionTypes";

let VendorDetailsState = {
    sellerName: "",
    sellerPic: "",
    sellerId: "",
    sellerState: "",
    isLoading: false,
    error: "",
    sellerMeData: null,
    sellerMeMessage: "",
    sellerMeLoaded: false,
}

const vendorDetailsReducer = (state = VendorDetailsState, action) => {
    // console.log(action)
    switch (action.type) {
        case "UPDATE_PIC_":
            return {
                ...state, sellerPic: action.payload
            }
        case ActionTypes.SELLER_ME_SUCCESS:
            return {
                ...state,
                sellerMeData: action.payload.data,
                sellerMeMessage: action.payload.message || "",
                sellerMeLoaded: true,
                sellerPic: action.payload.data?.avatar ?? state.sellerPic,
                sellerName: action.payload.data?.name ?? state.sellerName,
                sellerId: action.payload.data?._id ?? state.sellerId,
                sellerState: action.payload.data?.activeState ?? state.sellerState,
            };
        case ActionTypes.SELLER_ME_RESET:
            return {
                ...state,
                sellerMeData: null,
                sellerMeMessage: "",
                sellerMeLoaded: false,
            };
        default:
            // console.log(state)
            return state
    }
}
export default vendorDetailsReducer